import { World } from '@ecs/World';
import { Entity } from '@ecs/Entity';
import { CameraShake } from '@components/CameraShake';

export function getCameraShake(world: World): CameraShake {
  const existing = world.getEntitiesWithComponents(CameraShake)[0];
  if (existing) return existing.getComponent(CameraShake)!;

  const shake = new CameraShake();
  world.addEntity(new Entity().addComponent(shake));
  return shake;
}

export function addCameraTrauma(world: World, amount: number): void {
  const shake = getCameraShake(world);
  shake.trauma = Math.min(1, shake.trauma + amount);
}

/** Random screen offset for the current shake. `random` returns values in [0, 1). */
export function getCameraOffset(shake: CameraShake, random: () => number = Math.random): { x: number; y: number } {
  if (shake.trauma <= 0) return { x: 0, y: 0 };
  const magnitude = shake.maxOffset * shake.trauma * shake.trauma;
  return {
    x: (random() * 2 - 1) * magnitude,
    y: (random() * 2 - 1) * magnitude,
  };
}
